'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FETCH_PICKUP_LOCATIONS_BY_TERM = exports.FETCH_PICKUP_LOCATIONS_BY_TERM = 'FETCH_PICKUP_LOCATIONS_BY_TERM';
var FETCH_PICKUP_LOCATIONS_BY_TERM_SUCCESS = exports.FETCH_PICKUP_LOCATIONS_BY_TERM_SUCCESS = 'FETCH_PICKUP_LOCATIONS_BY_TERM_SUCCESS';
var FETCH_PICKUP_LOCATIONS_BY_TERM_FAILURE = exports.FETCH_PICKUP_LOCATIONS_BY_TERM_FAILURE = 'FETCH_PICKUP_LOCATIONS_BY_TERM_FAILURE';
var SELECT_PICKUP_LOCATION = exports.SELECT_PICKUP_LOCATION = 'SELECT_PICKUP_LOCATION';
var CONFIRM_PICKUP_LOCATION = exports.CONFIRM_PICKUP_LOCATION = 'CONFIRM_PICKUP_LOCATION';
var GPS_UNAVAILABLE = exports.GPS_UNAVAILABLE = 'GPS_UNAVAILABLE';

var getSearchTerm = function getSearchTerm(query) {
  if (typeof query === 'string') return query;
  return query.latitude + ', ' + query.longitude;
};

var fetchPickupLocationsByTerm = exports.fetchPickupLocationsByTerm = function fetchPickupLocationsByTerm(query) {
  var term = getSearchTerm(query);

  return {
    type: FETCH_PICKUP_LOCATIONS_BY_TERM,
    term: term,
    promise: function promise(_ref) {
      var api = _ref.api;
      return api('/pickup-locations/by-term').get({ term: term });
    },
    gps: typeof query !== 'string'
  };
};

var selectPickupLocation = exports.selectPickupLocation = function selectPickupLocation(id) {
  return {
    type: SELECT_PICKUP_LOCATION, id: id
  };
};

var confirmPickupLocation = exports.confirmPickupLocation = function confirmPickupLocation(details) {
  return {
    type: CONFIRM_PICKUP_LOCATION, details: details
  };
};

var gpsUnavailable = exports.gpsUnavailable = function gpsUnavailable() {
  return {
    type: GPS_UNAVAILABLE
  };
};


//////////////////
// WEBPACK FOOTER
// ./shared/actions/pickupLocations.js
// module id = 337
// module chunks = 0